module.exports = __webpack_public_path__ + "static/media/logo.d5e06463.png";